import { useAuthContext } from './useAuthContext';
import { useMemo } from 'react';

function useUserData() {
  const { userData, azTests } = useAuthContext();

  return useMemo(
    () =>
      userData
        ? {
            ...userData,
            isRegion: userData.userType === 'region',
            isLargeCity: !!userData.largeCity,
            isMunicipality: userData.userType === 'municipality',
            isCityDistrict: userData.userType === 'citydistrict',
            azTests,
          }
        : null,
    [userData, azTests],
  );
}

export default useUserData;
